import { Button } from "devextreme-react";

export default function HospURL(cellData) {
  const onClick = () => {
    window.open(cellData.data.hospUrl);
  };
  return (
    // <div>
    //   <a href={cellData.data.hospUrl} target="_blank">
    //     {cellData.data.LAB_NAME}
    //   </a>
    // </div>
    <div>
      <Button
        icon="home"
        onClick={onClick}
        disabled={cellData.data.hospUrl ? false : true}
      />
    </div>
  );
}
